/**
 * Jeu d'icônes SVG du menu principal (5 entrées), style trait fin cohérent.
 * Source unique de vérité : les chemins sont inlinés via <PrimaryIcon /> et
 * héritent de la couleur (`stroke="currentColor"`), ce qui permet de colorer
 * naturellement l'état actif/survol sans dépendre d'un chargement <img>.
 */
export const PRIMARY_ICON_BY_ID: Record<string, string> = {
  accueil: '<path d="M3 11.5L12 4l9 7.5" /><path d="M5 21V11h14v10" />',
  opportunites: '<circle cx="12" cy="12" r="8.5" /><path d="M12 7.5v9M7.5 12h9" />',
  missions: '<rect x="3" y="7" width="18" height="13" rx="2" /><path d="M16 3v4" />',
  finances: '<path d="M4 19V5M4 19h16" /><path d="m7 15 3-4 3 2 5-7" />',
  documents: '<path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5M9 13h6M9 17h6" />',
  create: '<path d="M12 5v14M5 12h14" />',
  profil: '<circle cx="12" cy="8" r="3" /><path d="M5 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" />',
};
